module.exports = __webpack_public_path__ + "img/115.bb25bb7a.jpg";